(function () {
  'use strict';

  var MIN_CHARS = 2;
  var MAX_LIVE_RESULTS = 4;
  var MAX_INDEX_PAGES = 4;
  var DISPLAY_PARAM = 'teklila_q';
  var VISIBLE_CLASS = 'predictive-search-wrapper--visible';

  var indexPromise = null;
  var products = [];
  var vocabulary = [];
  var timer = null;
  var searchRun = 0;


  /* =========================================================
     TEXT HELPERS
     ========================================================= */

  function clean(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }


  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[–—_-]/g, ' ')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }


  function words(value) {
    var normalized = normalize(value);

    return normalized
      ? normalized.split(' ').filter(Boolean)
      : [];
  }


  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }


  function escapeShopifyPhrase(value) {
    return String(value || '')
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"');
  }


  /* =========================================================
     SHOPIFY PRODUCT INDEX
     ========================================================= */

  function rootPath() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }


  function indexUrl(page) {
    var url = new URL(
      rootPath() + 'collections/all',
      window.location.origin
    );

    url.searchParams.set(
      'section_id',
      'teklila-search-index'
    );

    url.searchParams.set(
      'page',
      String(page)
    );

    return url.pathname + url.search;
  }


  function fetchIndexPage(page) {
    return fetch(
      indexUrl(page),
      {
        credentials: 'same-origin'
      }
    )

      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'TEKLILA search index request failed: ' +
            response.status
          );
        }

        return response.text();
      })

      .then(function (text) {
        var doc =
          new DOMParser().parseFromString(
            text,
            'text/html'
          );

        var node =
          doc.querySelector(
            '[data-teklila-search-index]'
          );

        if (!node) {
          throw new Error(
            'TEKLILA search index data was not found.'
          );
        }

        return JSON.parse(
          node.textContent
        );
      });
  }


  function prepareProduct(product) {
    var tags =
      Array.isArray(product.tags)
        ? product.tags
        : [];

    var normalizedTags =
      tags
        .map(normalize)
        .filter(Boolean);

    var tagWords = [];


    normalizedTags.forEach(function (tag) {
      tag
        .split(' ')
        .forEach(function (word) {
          if (word) {
            tagWords.push(word);
          }
        });
    });


    return {
      raw: product,

      title:
        normalize(product.title),

      titleWords:
        words(product.title),

      tags:
        normalizedTags,

      tagWords:
        tagWords
    };
  }


  function buildVocabulary() {
    var set =
      new Set();


    products.forEach(function (product) {

      product.titleWords
        .concat(product.tagWords)
        .forEach(function (word) {

          if (word.length >= 3) {
            set.add(word);
          }

        });

    });


    vocabulary =
      Array.from(set);
  }


  function loadIndex() {

    if (indexPromise) {
      return indexPromise;
    }


    indexPromise =
      fetchIndexPage(1)

        .then(function (firstPage) {

          var numberOfPages =
            Math.min(
              Number(firstPage.pages || 1),
              MAX_INDEX_PAGES
            );


          var requests = [];


          for (
            var page = 2;
            page <= numberOfPages;
            page += 1
          ) {

            requests.push(
              fetchIndexPage(page)
            );

          }


          return Promise
            .all(requests)

            .then(function (additionalPages) {

              var allProducts =
                (firstPage.products || [])
                  .slice();


              additionalPages
                .forEach(function (part) {

                  allProducts =
                    allProducts.concat(
                      part.products || []
                    );

                });


              return allProducts;
            });

        })

        .then(function (allProducts) {

          var seen =
            new Set();


          products =
            allProducts

              .filter(function (product) {

                var id =
                  String(product.id);


                if (seen.has(id)) {
                  return false;
                }


                seen.add(id);

                return true;
              })

              .map(prepareProduct);


          buildVocabulary();


          return products;
        })

        .catch(function (error) {

          indexPromise = null;

          console.error(error);

          throw error;
        });


    return indexPromise;
  }


  /* =========================================================
     TYPO CORRECTION
     ========================================================= */

  function distance(a, b) {

    var matrix = [];
    var i;
    var j;


    for (
      i = 0;
      i <= a.length;
      i += 1
    ) {
      matrix[i] = [i];
    }


    for (
      j = 0;
      j <= b.length;
      j += 1
    ) {
      matrix[0][j] = j;
    }


    for (
      i = 1;
      i <= a.length;
      i += 1
    ) {

      for (
        j = 1;
        j <= b.length;
        j += 1
      ) {

        var cost =
          a.charAt(i - 1) ===
          b.charAt(j - 1)
            ? 0
            : 1;


        matrix[i][j] =
          Math.min(

            matrix[i - 1][j] + 1,

            matrix[i][j - 1] + 1,

            matrix[i - 1][j - 1] +
              cost

          );


        if (
          i > 1 &&
          j > 1 &&
          a.charAt(i - 1) ===
            b.charAt(j - 2) &&
          a.charAt(i - 2) ===
            b.charAt(j - 1)
        ) {

          matrix[i][j] =
            Math.min(
              matrix[i][j],
              matrix[i - 2][j - 2] +
                cost
            );

        }

      }

    }


    return matrix[a.length][b.length];
  }


  function correctWord(word) {

    if (word.length < 4) {
      return word;
    }


    var alreadyValidPrefix =
      vocabulary.some(
        function (candidate) {

          return (
            candidate.indexOf(word) === 0
          );

        }
      );


    if (alreadyValidPrefix) {
      return word;
    }


    var allowedDistance =
      word.length >= 8
        ? 2
        : 1;


    var best =
      word;

    var bestDistance =
      Infinity;

    var tie =
      false;


    vocabulary.forEach(
      function (candidate) {

        if (
          candidate.charAt(0) !==
          word.charAt(0)
        ) {
          return;
        }


        if (
          Math.abs(
            candidate.length -
            word.length
          ) >
          allowedDistance
        ) {
          return;
        }


        var currentDistance =
          distance(
            word,
            candidate
          );


        if (
          currentDistance <
          bestDistance
        ) {

          best =
            candidate;

          bestDistance =
            currentDistance;

          tie =
            false;

        } else if (
          currentDistance ===
          bestDistance
        ) {

          tie =
            true;

        }

      }
    );


    if (
      !tie &&
      bestDistance <=
        allowedDistance
    ) {
      return best;
    }


    return word;
  }


  /* =========================================================
     MATCHING + RANKING
     ========================================================= */

  function tokenScore(
    term,
    product
  ) {

    var score = 0;


    product.titleWords
      .forEach(function (word) {

        if (word === term) {

          score =
            Math.max(
              score,
              900
            );

        } else if (
          word.indexOf(term) === 0
        ) {

          score =
            Math.max(
              score,
              800
            );

        }

      });


    product.tags
      .forEach(function (tag) {

        if (tag === term) {

          score =
            Math.max(
              score,
              750
            );

        } else if (
          tag.indexOf(term) === 0
        ) {

          score =
            Math.max(
              score,
              700
            );

        }

      });


    product.tagWords
      .forEach(function (word) {

        if (word === term) {

          score =
            Math.max(
              score,
              650
            );

        } else if (
          word.indexOf(term) === 0
        ) {

          score =
            Math.max(
              score,
              600
            );

        }

      });


    return score;
  }


  function findMatches(
    value,
    limit
  ) {

    var queryWords =
      words(value)
        .map(correctWord);


    if (!queryWords.length) {
      return [];
    }


    var resolvedQuery =
      queryWords.join(' ');


    var matches =
      products

        .map(function (
          product,
          index
        ) {

          var score = 0;


          for (
            var i = 0;
            i < queryWords.length;
            i += 1
          ) {

            var currentScore =
              tokenScore(
                queryWords[i],
                product
              );


            if (!currentScore) {
              return null;
            }


            score +=
              currentScore;
          }


          if (
            product.title ===
            resolvedQuery
          ) {

            score +=
              5000;

          } else if (
            product.title.indexOf(
              resolvedQuery
            ) === 0
          ) {

            score +=
              4000;

          }


          if (
            product.tags.indexOf(
              resolvedQuery
            ) !== -1
          ) {

            score +=
              3000;

          } else if (

            product.tags.some(
              function (tag) {

                return (
                  tag.indexOf(
                    resolvedQuery
                  ) === 0
                );

              }
            )

          ) {

            score +=
              2500;

          }


          return {

            product:
              product.raw,

            score:
              score,

            order:
              index

          };
        })

        .filter(Boolean)

        .sort(function (a, b) {

          return (
            b.score -
              a.score ||
            a.order -
              b.order
          );

        })

        .map(function (match) {

          return match.product;

        });


    if (
      typeof limit ===
      'number'
    ) {

      return matches.slice(
        0,
        limit
      );

    }


    return matches;
  }


  /* =========================================================
     LIVE PRODUCT CARD
     ========================================================= */

  function productCard(product) {

    var image =
      product.image

        ? '<img ' +
          'src="' +
          escapeHtml(product.image) +
          '" ' +
          'alt="' +
          escapeHtml(product.title) +
          '" ' +
          'loading="lazy" ' +
          'class="w:100% h:100% obf:cover">'

        : '<div ' +
          'class="w:100% h:100% bg:foreground.02">' +
          '</div>';


    return (

      '<a ' +
      'href="' +
      escapeHtml(product.url) +
      '" ' +
      'data-search-result ' +
      'class="' +
      'xo-predictive-search-base__item ' +
      'focus-inset ' +
      'd:flex ' +
      'ai:center ' +
      'jc:flex-start ' +
      'fld:column ' +
      'gp:s9 ' +
      'group*' +
      '" ' +
      'aria-label="' +
      escapeHtml(product.title) +
      '">' +

        '<div ' +
        'class="' +
        'xo-predictive-search-base__image ' +
        'ar:3/4 ' +
        'd:flex ' +
        'ai:center ' +
        'jc:center ' +
        'flxs:0 ' +
        'ov:hidden' +
        '">' +

          image +

        '</div>' +

        '<div ' +
        'class="' +
        'xo-predictive-search-base__wrap ' +
        'd:flex ' +
        'fld:column ' +
        'ai:center ' +
        'jc:center' +
        '">' +

          '<p ' +
          'class="' +
          'xo-predictive-search-base__title ' +
          'c:foreground ' +
          'ff:body ' +
          'fz:s4 ' +
          'fw:400 ' +
          'tt:uppercase ' +
          'lh:1.5 ' +
          'ta:center' +
          '">' +

            escapeHtml(
              product.title
            ) +

          '</p>' +

          '<span ' +
          'class="' +
          'xo-predictive-search-base__price ' +
          'c:foreground ' +
          'fz:s5 ' +
          'fw:700 ' +
          'lh:1.5' +
          '">' +

            escapeHtml(
              product.price
            ) +

          '</span>' +

        '</div>' +

      '</a>'

    );
  }


  /* =========================================================
     LIVE RESULTS MARKUP
     ========================================================= */

  function resultsHtml(matches) {

    return (

      '<div ' +
      'class="' +
      'xo-predictive-search-base__inner ' +
      'w:100%' +
      '">' +

        '<div ' +
        'class="' +
        'xo-predictive-search-base__container ' +
        'w:100%' +
        '">' +

          '<div ' +
          'class="' +
          'xo-predictive-search-base__content ' +
          'xo-scrollbar' +
          '">' +

            '<xo-grid ' +
            'class="' +
            'xo-predictive-search-base__grid ' +
            'rg:s10 ' +
            'rg:s12@lg ' +
            'cg:s6' +
            '">' +

              '<div ' +
              'class="' +
              'xo-predictive-search-base__product' +
              '" ' +
              'style="' +
              '--xs:12;' +
              '--md:12;' +
              '--lg:12' +
              '">' +

                '<h3 ' +
                'class="' +
                'xo-predictive-search-base__heading ' +
                'pb:s3 ' +
                'm:s0 ' +
                'ff:body ' +
                'fz:s5 ' +
                'fw:700 ' +
                'lh:1.5 ' +
                'lts:0.2rem ' +
                'c:foreground ' +
                'tt:uppercase' +
                '">' +

                  'PRODUCTS' +

                '</h3>' +

                '<xo-grid ' +
                'class="' +
                'xo-predictive-search-base__list ' +
                'pt:s9' +
                '" ' +
                'style="' +
                '--xs:2;' +
                '--lg:2' +
                '">' +

                  matches
                    .map(
                      productCard
                    )
                    .join('') +

                '</xo-grid>' +

              '</div>' +

            '</xo-grid>' +

          '</div>' +

          '<div ' +
          'class="' +
          'xo-predictive-search-base__bottom ' +
          'w:100% ' +
          'd:flex ' +
          'ai:center ' +
          'jc:center ' +
          'pt:s11 ' +
          'pt:s13@md' +
          '">' +

            '<button ' +
            'type="submit" ' +
            'class="' +
            'xo-predictive-search-base__view-all ' +
            'group* ' +
            'w:100% ' +
            'cur:pointer ' +
            'bg:button-background ' +
            'bd:s1 ' +
            'bdc:button-background ' +
            'p:s8 ' +
            'trs:0.3s ' +
            'bg:button-background-inverse|h' +
            '">' +

              '<span ' +
              'class="' +
              'c:button-text ' +
              'tt:uppercase ' +
              'fz:s3 ' +
              'fw:500 ' +
              'lh:1.5' +
              '">' +

                'VIEW ALL RESULTS' +

              '</span>' +

            '</button>' +

          '</div>' +

        '</div>' +

      '</div>'

    );
  }


  /* =========================================================
     TEKLILA DRAWER — NO RESULTS
     ========================================================= */

  function emptyHtml(query) {

    var collectionUrl =
      rootPath() +
      'collections/the-heritage-collection';


    return (

      '<div ' +
      'class="' +
      'xo-predictive-search-base__inner ' +
      'w:100%' +
      '" ' +
      'style="' +
      'padding-top:4.4rem;' +
      'padding-bottom:3rem;' +
      '">' +

        '<div ' +
        'style="' +
        'max-width:42rem;' +
        'text-align:left;' +
        '">' +

          '<h3 ' +
          'class="' +
          'ff:heading ' +
          'c:foreground' +
          '" ' +
          'style="' +
          'margin:0;' +
          'font-size:2.6rem;' +
          'font-weight:500;' +
          'line-height:1.2;' +
          '">' +

            'No results for “' +
            escapeHtml(query) +
            '”' +

          '</h3>' +


          '<p ' +
          'class="' +
          'ff:body ' +
          'c:foreground' +
          '" ' +
          'style="' +
          'margin:1.2rem 0 0;' +
          'font-size:1.5rem;' +
          'font-weight:400;' +
          'line-height:1.55;' +
          'opacity:.62;' +
          '">' +

            'Try another search term.' +

          '</p>' +


          '<a ' +
          'href="' +
          escapeHtml(collectionUrl) +
          '" ' +
          'class="' +
          'ff:body ' +
          'c:foreground' +
          '" ' +
          'style="' +
          'display:inline-flex;' +
          'align-items:center;' +
          'gap:.55rem;' +
          'margin-top:2.8rem;' +
          'font-size:1.25rem;' +
          'font-weight:500;' +
          'line-height:1.4;' +
          'letter-spacing:.08em;' +
          'text-transform:uppercase;' +
          'text-decoration:none;' +
          'border-bottom:1px solid color-mix(in srgb, rgb(var(--color-foreground)) 32%, transparent);' +
          'padding-bottom:.25rem;' +
          '">' +

            '<span>' +
              'View the Heritage Collection' +
            '</span>' +

            '<span aria-hidden="true">' +
              '→' +
            '</span>' +

          '</a>' +

        '</div>' +

      '</div>'

    );
  }


  function hideResults(
    input,
    result
  ) {

    result
      .classList
      .remove(
        VISIBLE_CLASS
      );


    result.innerHTML =
      '';


    input.setAttribute(
      'aria-expanded',
      'false'
    );
  }


  function showResults(
    input,
    result,
    markup
  ) {

    result.innerHTML =
      markup;


    result
      .classList
      .add(
        VISIBLE_CLASS
      );


    input.setAttribute(
      'aria-expanded',
      'true'
    );
  }


  function runSearch(
    input,
    result
  ) {

    var query =
      clean(
        input.value
      );


    if (
      normalize(query).length <
      MIN_CHARS
    ) {

      searchRun += 1;


      hideResults(
        input,
        result
      );


      return;
    }


    var currentRun =
      ++searchRun;


    loadIndex()

      .then(function () {

        if (
          currentRun !==
            searchRun ||
          clean(input.value) !==
            query
        ) {

          return;
        }


        var matches =
          findMatches(
            query,
            MAX_LIVE_RESULTS
          );


        if (
          matches.length
        ) {

          showResults(
            input,
            result,
            resultsHtml(matches)
          );

        } else {

          showResults(
            input,
            result,
            emptyHtml(query)
          );

        }

      })

      .catch(function () {

        if (
          currentRun ===
          searchRun
        ) {

          hideResults(
            input,
            result
          );

        }

      });
  }


  /* =========================================================
     FULL RESULTS PAGE
     ========================================================= */

  function exactTitleQuery(matches) {

    if (!matches.length) {

      return (
        'title:"__teklila_no_matching_product__"'
      );
    }


    return matches

      .map(function (product) {

        return (
          'title:"' +
          escapeShopifyPhrase(
            product.title
          ) +
          '"'
        );

      })

      .join(' OR ');
  }


  function fallbackSearchUrl(
    displayQuery,
    action
  ) {

    var url =
      new URL(
        action ||
          rootPath() +
            'search',
        window.location.origin
      );


    url.searchParams.set(
      'q',
      displayQuery
    );


    url.searchParams.set(
      'type',
      'product'
    );


    url.searchParams.set(
      'options[prefix]',
      'last'
    );


    url.searchParams.set(
      DISPLAY_PARAM,
      displayQuery
    );


    return url;
  }


  function goToResults(
    displayQuery,
    action
  ) {

    displayQuery =
      clean(
        displayQuery
      );


    if (
      !displayQuery ||
      normalize(displayQuery).length <
        MIN_CHARS
    ) {

      return;
    }


    loadIndex()

      .then(function () {

        var matches =
          findMatches(
            displayQuery
          );


        var url =
          new URL(
            action ||
              rootPath() +
                'search',
            window.location.origin
          );


        url.searchParams.set(
          'q',
          exactTitleQuery(matches)
        );


        url.searchParams.set(
          'type',
          'product'
        );


        url.searchParams.set(
          DISPLAY_PARAM,
          displayQuery
        );


        window.location.assign(
          url.pathname +
          url.search
        );
      })

      .catch(function () {

        var fallback =
          fallbackSearchUrl(
            displayQuery,
            action
          );


        window.location.assign(
          fallback.pathname +
          fallback.search
        );
      });
  }


  /* =========================================================
     HEADER / DRAWER INITIALIZATION
     ========================================================= */

  function initHeaderSearch() {

    var form =
      document.querySelector(
        '[data-teklila-search-form]'
      );


    var input =
      document.querySelector(
        '[data-teklila-search-input="header"]'
      );


    var result =
      document.querySelector(
        '[data-teklila-search-results="header"]'
      );


    if (
      !form ||
      !input ||
      !result
    ) {

      return;
    }


    input.setAttribute(
      'autocomplete',
      'off'
    );


    input.setAttribute(
      'autocorrect',
      'off'
    );


    input.setAttribute(
      'autocapitalize',
      'off'
    );


    input.setAttribute(
      'spellcheck',
      'false'
    );


    input.setAttribute(
      'role',
      'combobox'
    );


    input.setAttribute(
      'aria-expanded',
      'false'
    );


    input.setAttribute(
      'aria-controls',
      'teklila-predictive-results'
    );


    result.id =
      'teklila-predictive-results';


    input.addEventListener(
      'focus',
      function () {

        loadIndex()
          .catch(function () {});


        if (
          normalize(
            input.value
          ).length >=
          MIN_CHARS
        ) {

          runSearch(
            input,
            result
          );

        }

      }
    );


    input.addEventListener(
      'input',
      function () {

        clearTimeout(
          timer
        );


        timer =
          setTimeout(
            function () {

              runSearch(
                input,
                result
              );

            },
            120
          );

      }
    );
  }


  /* =========================================================
     SEARCH SUBMISSION
     ========================================================= */

  document.addEventListener(
    'submit',
    function (event) {

      var form =
        event.target;


      if (
        form instanceof
          HTMLFormElement &&
        form.matches(
          '[data-teklila-search-form]'
        )
      ) {

        var headerInput =
          form.querySelector(
            '[data-teklila-search-input="header"]'
          );


        if (!headerInput) {
          return;
        }


        event.preventDefault();


        goToResults(
          headerInput.value,
          form.action
        );


        return;
      }


      if (
        form instanceof
          HTMLFormElement &&
        form.matches(
          '[data-teklila-results-search-form]'
        )
      ) {

        var resultsInput =
          form.querySelector(
            '[data-teklila-results-search-input]'
          );


        if (!resultsInput) {
          return;
        }


        event.preventDefault();


        goToResults(
          resultsInput.value,
          form.action
        );

      }

    },
    true
  );


  /* =========================================================
     THEME-EDITOR SUGGESTION LINKS
     ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      var link =
        event.target.closest(
          '[data-teklila-search-suggestion]'
        );


      if (!link) {
        return;
      }


      var displayQuery =
        clean(
          link.getAttribute(
            'data-teklila-search-suggestion'
          )
        );


      if (!displayQuery) {
        return;
      }


      event.preventDefault();


      goToResults(
        displayQuery,
        rootPath() +
          'search'
      );
    }
  );


  /* =========================================================
     CUSTOMER-FACING RESULTS-PAGE QUERY
     ========================================================= */

  function getDisplayQuery() {

    if (
      window.location.pathname
        .indexOf('/search') ===
      -1
    ) {

      return '';
    }


    var params =
      new URLSearchParams(
        window.location.search
      );


    return clean(
      params.get(
        DISPLAY_PARAM
      )
    );
  }


  function restoreDisplayQuery() {

    var displayQuery =
      getDisplayQuery();


    if (!displayQuery) {
      return;
    }


    document
      .querySelectorAll(
        '[data-teklila-search-display]'
      )
      .forEach(
        function (element) {

          if (
            element.hasAttribute(
              'data-teklila-search-quoted'
            )
          ) {

            element.textContent =
              '“' +
              displayQuery +
              '”';

          } else {

            element.textContent =
              displayQuery;

          }

        }
      );


    document
      .querySelectorAll(
        '[data-teklila-results-search-input]'
      )
      .forEach(
        function (input) {

          input.value =
            displayQuery;

        }
      );
  }


  function start() {

    initHeaderSearch();

    restoreDisplayQuery();
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      start
    );

  } else {

    start();

  }


  /* =========================================================
     DEBUGGING
     ========================================================= */

  window.TeklilaSearch = {

    loadIndex:
      loadIndex,

    findMatches:
      function (query) {

        return loadIndex()

          .then(function () {

            return findMatches(
              query
            );

          });

      },

    goToResults:
      goToResults
  };

})();